import React from "react";
import { LoadDefHomeContainer } from "../../../containers";
const LoadDefinitionHome = (props) => {
  return <LoadDefHomeContainer {...props} />;
};

export default LoadDefinitionHome;
